import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonModal,
    IonSpinner,
} from '@ionic/react';
import React from 'react';

interface AsteriskMessageConfirmDialogProps {
    isOpen: boolean;
    title: string;
    message: React.ReactNode;
    confirmLabel: string;
    busyLabel?: string;
    isBusy?: boolean;
    destructive?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const AsteriskMessageConfirmDialog: React.FC<AsteriskMessageConfirmDialogProps> = ({
    isOpen,
    title,
    message,
    confirmLabel,
    busyLabel = 'Bezig…',
    isBusy = false,
    destructive = false,
    onCancel,
    onConfirm,
}) => (
    <IonModal
        isOpen={isOpen}
        className="asterisk-confirm-modal"
        canDismiss={async () => !isBusy}
        onDidDismiss={() => {
            if (!isBusy) onCancel();
        }}
    >
        <IonContent className="ion-padding">
            <IonCard role="alertdialog" aria-modal="true" aria-labelledby="asterisk-confirm-title">
                <IonCardHeader>
                    <IonCardTitle id="asterisk-confirm-title">{title}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <div className="asterisk-confirm-copy">{message}</div>
                    <div className="asterisk-confirm-actions">
                        <IonButton fill="outline" onClick={onCancel} disabled={isBusy}>
                            Annuleren
                        </IonButton>
                        <IonButton color={destructive ? 'danger' : 'primary'} onClick={onConfirm} disabled={isBusy}>
                            {isBusy && <IonSpinner name="crescent" aria-hidden="true"/>}
                            {isBusy ? busyLabel : confirmLabel}
                        </IonButton>
                    </div>
                </IonCardContent>
            </IonCard>
        </IonContent>
    </IonModal>
);

export default AsteriskMessageConfirmDialog;
